import { Box, Button, Tabs, Text } from "@mantine/core";
import React, { useState, useEffect } from "react";
import { FileFolderRadio, RowGridRadio } from "./radio";

import { useSelector } from "react-redux";
import { IconFolderPlus, IconArrowLeft } from "@tabler/icons-react";
import { FileItem, FileTable } from "./file";
import { FolderItem, FolderTable } from "./folder";
import useStyles from "./styles";
import UploadDocument from "./uploadDocument";
import SearchBar from "./searchBar";
import TableLoader from "../TableLoader";
import { useDisclosure } from "@mantine/hooks";
import CreateFolderModal from "./CreateFolderModal";
import { getFiles, getFolders } from "../../services/Document";
import RecordNotFound from "../RecordNotFound";
import UploadStaffDoc from "../StaffDetails/UploadStaffDoc";
import UploadFolderSvg from "../Svgs/UploadFolderSvg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { isStaff } from "../../http";

function Document({ client }) {
  const { classes } = useStyles();
  const [type, setType] = useState("folder");
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [view, setView] = useState("grid");
  const [expiredTabLoading, setExpiredTabLoading] = useState(false);
  const [tabState, setTabState] = useState("active");
  const [opened, { open, close }] = useDisclosure(false);
  const { getFolderLoading, folders, files, getFileLoading } = useSelector(
    (state) => state.document
  );

  const { profile } = useSelector((state) => state?.profile);

  const getFoldersData = async () => {
    await getFolders(client, "client");
  };

  const getFilesData = async () => {
    await getFiles(client, "client", selectedFolder?._id || selectedFolder?.id);
  };
  useEffect(() => {
    if (type === "folder") {
      getFoldersData();
    } else {
      getFilesData();
    }
  }, [type, selectedFolder]);

  useEffect(() => {
    if (tabState == "expired") {
      setExpiredTabLoading(true);
      setTimeout(() => {
        setExpiredTabLoading(false);
      }, 2000);
    }
  }, [tabState]);

  const GridView = () => {
    return (
      <div>
        {type === "file" ? (
          <>
            <Text my={5} ta={"center"} fw={"bold"} fz={18} ff={"Inter"}>
              {selectedFolder ? selectedFolder?.name : "All Documents"}
            </Text>
            <div
              style={{ justifyContent: files ? "start" : "center" }}
              className={classes.row}
            >
              {getFileLoading ? (
                <TableLoader />
              ) : (
                <>
                  <Tabs
                    value={tabState}
                    style={{ width: "100%" }}
                    className={classes.activeAndInactiveTab}
                    onTabChange={(e) => {
                      setTabState(e);
                    }}
                  >
                    <Tabs.List style={{ gap: "39px" }}>
                      <Tabs.Tab value="active">Active</Tabs.Tab>
                      <Tabs.Tab value="expired">Expired</Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel value="active">
                      <div
                        style={{
                          width: "100%",
                          marginTop: "1rem",
                          display: "flex",
                          alignItems: "start",
                          columnGap: "1rem",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* {console.log('selectedFolder isis',selectedFolder)} */}

                        {files?.folderInfo &&
                          files?.folderInfo?.folders?.length > 0 &&
                          files?.folderInfo?.folders?.map((folder) => (
                            <FolderItem
                              key={folder._id}
                              data={folder}
                              setSelectedFolder={setSelectedFolder}
                              setType={setType}
                              client={client}
                            />
                          ))}

                        {files?.activeFiles?.map((file) => (
                          <FileItem client={client} data={file} />
                        ))}
                      </div>
                    </Tabs.Panel>
                    <Tabs.Panel value="expired">
                      <div
                        style={{
                          width: "100%",
                          marginTop: "1rem",
                          display: "flex",
                          alignItems: "start",
                          columnGap: "1rem",
                          flexWrap: "wrap",
                        }}
                      >
                        {expiredTabLoading ? (
                          <TableLoader color="yellow" size={"md"} />
                        ) : files?.expiredFiles?.length > 0 ? (
                          files?.expiredFiles?.map((file) => (
                            <FileItem client={client} data={file} />
                          ))
                        ) : (
                          <Box className={classes.notFoundTextContainer}>
                            <RecordNotFound />
                            <Text className={classes.notFoundText}>
                              You don&apos;t have any files uploaded to this
                              folder, click on “upload documents” to add.
                            </Text>
                          </Box>
                        )}
                      </div>
                    </Tabs.Panel>
                  </Tabs>
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              className={classes.row}
              style={{
                justifyContent: folders?.length > 0 ? "start" : "center",
              }}
            >
              {getFolderLoading ? (
                <TableLoader />
              ) : folders?.length > 0 ? (
                folders?.map((folder) => (
                  <FolderItem
                    data={folder}
                    setSelectedFolder={setSelectedFolder}
                    setType={setType}
                    client={client}
                  />
                ))
              ) : (
                <Box className={classes.notFoundTextContainer}>
                  <RecordNotFound />
                  <Text className={classes.notFoundText}>
                    You don&apos;t have any folders, click on the folder icon
                    above to add.
                  </Text>
                </Box>
              )}
            </div>
          </>
        )}
      </div>
    );
  };
  const TableView = () => {
    return (
      <div>
        {type === "file" ? (
          <>
            <Text my={5} ta={"center"} fw={"bold"} fz={18} ff={"Inter"}>
              {selectedFolder ? selectedFolder?.name : "All Documents"}
            </Text>

            {getFileLoading ? (
              <TableLoader />
            ) : (
              <Tabs
                value={tabState}
                style={{ width: "100%" }}
                color="yellow"
                className={classes.activeAndInactiveTab}
                onTabChange={(e) => {
                  setTabState(e);
                }}
              >
                <Tabs.List style={{ gap: "39px" }}>
                  <Tabs.Tab value="active">Active</Tabs.Tab>
                  <Tabs.Tab value="expired">Expired</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="active">
                  {selectedFolder?.folders?.length > 0 &&
                    selectedFolder?.folders?.map((folder) => (
                      <FolderItem
                        key={folder._id}
                        data={folder}
                        setSelectedFolder={setSelectedFolder}
                        setType={setType}
                        client={client}
                      />
                    ))}
                  <FileTable client={client} data={files?.activeFiles} />
                </Tabs.Panel>
                <Tabs.Panel
                  value="expired"
                  onChange={(e) => console.log("expired tab click", e)}
                >
                  <FileTable client={client} data={files?.expiredFiles} />
                </Tabs.Panel>
              </Tabs>
            )}
          </>
        ) : (
          <>
            {/* <Text my={5} ta={"center"}>
              All Folders
            </Text> */}
            {getFolderLoading ? (
              <TableLoader />
            ) : (
              <FolderTable
                setType={setType}
                setSelectedFolder={setSelectedFolder}
                folders={folders}
                client={client}
              />
            )}
          </>
        )}
      </div>
    );
  };
  return (
    <Box className={classes.documentsContent}>
      <SearchBar client={client} />
      <div
        className={classes.row}
        style={{
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <div
          className={classes.row}
          style={{
            justifyContent: "space-between",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          {/* <UploadDocument client={client} selectedFolder={selectedFolder} /> */}
          {!isStaff(profile?.user?.role) ? (
            <Button
              leftIcon={<UploadFolderSvg size={20} />}
              color="gray"
              variant="outline"
              onClick={() => {
                open();
              }}
              className={classes.iconButton}
              style={{ color: "black" }}
            >
              <Text>New Folder</Text>
            </Button>
          ) : null}
          <UploadStaffDoc
            selectedFolder={selectedFolder}
            userId={client}
            userType={"client"}
          />
          {/* <UnstyledButton
            color="yellow"
            onClick={() => {
              open();
            }}
            className={classes.iconButton}
          >
          </UnstyledButton> */}
        </div>
        <RowGridRadio onChange={(val) => setView(val)} />
      </div>
      {selectedFolder ? (
        <Box
          align="center"
          gap={5}
          m={10}
          onClick={() => {
            setSelectedFolder(null);
            setType("folder");
          }}
          style={{
            cursor: "pointer",
            width: "fit-content",
            display: "flex",
            alignItems: "center",
          }}
        >
          <MdKeyboardArrowLeft size={30} />
          <Text fw={400} fz={14} c={"#262626"} ff={"Inter"}>
            Back
          </Text>
        </Box>
      ) : (
        // <p style={{ display: "flex", alignItems: "center", color: "yellow" }}>
        //
        // </p>
        <FileFolderRadio onChange={(val) => setType(val)} />
      )}
      {view === "grid" ? <GridView /> : <TableView />}
      <CreateFolderModal
        opened={opened}
        client={client}
        onclose={() => {
          close();
        }}
        title={"Create New Folder"}
        selectedFolder={selectedFolder}
      />
    </Box>
  );
}

export default Document;
